import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useAppSelector } from "../../hooks/redux";
import BuyFormNew from "../../pages/dashboard/forms/buyforms/buyformnew";
const BuySellForm = () => {
    const buySellData = useAppSelector((state) => {
        return state.modals.buySellData;
    });
    return (_jsx(_Fragment, { children: buySellData && (_jsx(React.Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: _jsx(BuyFormNew, { scripData: buySellData }) }))) }));
};
export default BuySellForm;
